import { render, staticRenderFns } from "./ProductListDetailStock.vue?vue&type=template&id=db0fd870&scoped=true&"
import script from "./ProductListDetailStock.vue?vue&type=script&lang=js&"
export * from "./ProductListDetailStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductListDetailStock.vue?vue&type=style&index=0&id=db0fd870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0fd870",
  null
  
)

export default component.exports